/* content file: replace all html between <> </> with actual content */

export const Kontakt = () => { 
  return (
  <>
    <p className="mb-4">Sie wollen gerne mehr über GA-Lotse erfahren? Dann schreiben Sie uns:</p>
  </>    
  )
}